import { cn } from 'lib/utils'
import { Volume2, VolumeX } from 'lucide-react'

interface MuteChipProps {
  muted: boolean
  onToggle: (e: React.MouseEvent) => void
  /**
   * Overrides the default bottom-right placement/size. Used by the IdeaCard
   * video path to stack the chip above the ••• menu (which shares the
   * bottom-right corner). twMerge dedupes the conflicting position/size
   * utilities, so the override wins.
   */
  className?: string
}

/**
 * Speaker mute/unmute control overlaid on a video preview (bottom-right,
 * Instagram-style). Shared by the composer preview (`PreviewVideo`) and the
 * card/feed path (`AssetMedia`) so the affordance stays identical everywhere.
 */
export function MuteChip({ muted, onToggle, className }: MuteChipProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={muted ? 'Unmute video' : 'Mute video'}
      aria-pressed={muted}
      className={cn(
        'absolute right-3 bottom-3 z-20 flex h-9 w-9 items-center justify-center rounded-full bg-black/45 text-white backdrop-blur-sm transition-colors hover:bg-black/75 focus:bg-black/75',
        className
      )}
    >
      {muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
    </button>
  )
}
